/* eslint-disable react/no-did-mount-set-state */
import React from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import VouchersApi from '../../../api/open-voucher';
import Tabs from '../../tabs/index';
import VoucherInfo from '../voucher-productos/voucher-info';
import Detalle from './detalle/detalle';
import PaymentApi from '../../../api/payment';
import { addPromotions } from '../../../redux/actions/selectActions';
import './detalle/detalle.css';
import './index-productos-detalle.css';
import '../voucher-productos/voucher-info.css';

class ProductoDetalle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      ofertas: null,
      producto: null,
      infoAdicional: null,
      indexOfertaSeleccionada: 0,
      error: { status: false, msg: '' },
    };
    this.handleOnChangeNights = this.handleOnChangeNights.bind(this);
  }

  obtenerPartesDePathname = () => {
    const pathname = isClient ? window.location.pathname : ''.replace('/buscarxpaquetes', '');

    const path = pathname[pathname.length - 1] === '/'
      ? pathname.substring(0, pathname.length - 1)
      : pathname;

    return path.split('/');
  }

  async componentDidMount() {
    const { app, actions } = this.props;
    const [,,, voucherTypeId, voucherSelectedId, productId] = this.obtenerPartesDePathname();

    const vouchers = await VouchersApi.getVouchers(app.token)
      .then((data) => (data.status ? data.object.ofertas : false));

    const productos = await VouchersApi.getProductsByTypeVoucherId(voucherTypeId, app.token)
      .then((data) => (data.status ? data.object : false));

    const infoAdicional = await VouchersApi.getAdditionalInfoByProductoId(productId, app.token)
      .then((data) => (data.status ? data.object : false));

    await PaymentApi.obtenerOpcionesPagoMundigea()
      .then((res) => actions.addPromotions(res.data));

    if (vouchers && vouchers.length > 0) {
      const byType = vouchers.filter((voucher) => parseInt(voucher.tipoVoucherId) === parseInt(voucherTypeId));

      const ordenedVoucherdOptions = byType.sort((a, b) => {
        return a.usoVoucher.cantidadUsos - b.usoVoucher.cantidadUsos;
      });
      let indexSelected = 0;
      ordenedVoucherdOptions.forEach((oferta, index) => {
        if (parseInt(oferta.id) === parseInt(voucherSelectedId)) {
          indexSelected = index;
        }
      });
      this.setState({
        ofertas: ordenedVoucherdOptions,
        producto: productos.default.filter((producto) => parseInt(producto.id) === parseInt(productId))[0],
        indexOfertaSeleccionada: indexSelected,
        infoAdicional,
        loading: false,
      });
    } else {
      this.setState({
        error: { status: true, msg: 'Hubo un errro y no encontramos lo que estas buscando' },
        loading: false,
      });
    }
  }

  handleOnChangeNights(newIndex) {
    this.setState({
      indexOfertaSeleccionada: newIndex,
    });
  }

  render() {
    const { producto, ofertas, indexOfertaSeleccionada, loading, error, infoAdicional } = this.state;
    const crearInfoProducto = () => {
      if (loading) {
        return (
          <div>
            <br />
            <br />
            <br />
            <img
              src='https://www.mundigea.com.ar/buscarxpaquetes/assets/img/loader2.gif'
              alt=''
              className='img-responsive center-block'
              style={{ height: 110, marginBottom: 42 }}
            />
            <br />
            <br />
            <br />
            <br />
            <br />
          </div>
        );
      }
      if (producto && ofertas && error.status === false) {
        return (
          <Detalle
            data={producto}
            additionalInfo={infoAdicional}
            voucherInfo={ofertas[indexOfertaSeleccionada]}
          />
        );
      }
      return (
        <>
          <br />
          <br />
          <h2 className='text-center'>No encontramos productos para este voucher</h2>
          <br />
          <br />
        </>
      );

    };
    return (
      <>
        <Tabs />
        <div className='producto-detalle'>
          <VoucherInfo
            indexSelected={indexOfertaSeleccionada}
            voucherOfertas={ofertas}
            onNightsChange={this.handleOnChangeNights}
          />
          <div className='container'>
            {crearInfoProducto()}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.applicationState,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ addPromotions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductoDetalle);
